import { Link } from 'react-router-dom';
import { featuredMovies } from '@/mocks/home';

export default function FeatureSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-950">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 md:mb-14 gap-4">
          <div>
            <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-500/10 text-accent-500 mb-3">
              热门推荐
            </span>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-50">
              午夜必看 · 精选好片
            </h2>
          </div>
          <Link
            to="/category/movies"
            className="flex items-center gap-1.5 text-sm font-medium text-primary-500 hover:text-primary-400 transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {featuredMovies.map((movie) => (
            <Link
              key={movie.id}
              to={movie.link}
              className="group relative cursor-pointer"
            >
              <div className="relative aspect-[3/4] rounded-xl overflow-hidden mb-3">
                <img
                  src={movie.image}
                  alt={movie.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/90 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 text-[10px] font-medium rounded bg-primary-500 text-background-950">
                    {movie.rating}
                  </span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-background-950">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <h3 className="text-foreground-100 text-sm font-medium line-clamp-1 group-hover:text-primary-500 transition-colors">
                {movie.title}
              </h3>
              <p className="text-foreground-600 text-xs mt-1">
                {movie.category} · {movie.year}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}